"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateExperimentStatusesRequestToJSON = exports.UpdateExperimentStatusesRequestFromJSONTyped = exports.UpdateExperimentStatusesRequestFromJSON = exports.instanceOfUpdateExperimentStatusesRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateExperimentStatusesRequest interface.
 */
function instanceOfUpdateExperimentStatusesRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateExperimentStatusesRequest = instanceOfUpdateExperimentStatusesRequest;
function UpdateExperimentStatusesRequestFromJSON(json) {
    return UpdateExperimentStatusesRequestFromJSONTyped(json, false);
}
exports.UpdateExperimentStatusesRequestFromJSON = UpdateExperimentStatusesRequestFromJSON;
function UpdateExperimentStatusesRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'experimentIds': !(0, runtime_1.exists)(json, 'experiment_ids') ? undefined : json['experiment_ids'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
    };
}
exports.UpdateExperimentStatusesRequestFromJSONTyped = UpdateExperimentStatusesRequestFromJSONTyped;
function UpdateExperimentStatusesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'experiment_ids': value.experimentIds,
        'status': value.status,
    };
}
exports.UpdateExperimentStatusesRequestToJSON = UpdateExperimentStatusesRequestToJSON;
